import React, { useState } from 'react';
import { api } from '../App';
import '../styles/LoginPage.css';

function LoginPage({ onLogin }) {
  const [inlognaam, setInlognaam] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/index.php?action=login', {
        inlognaam,
        wachtwoord
      });

      if (response.data.user) {
        onLogin(response.data.user);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Er is een fout opgetreden bij het inloggen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div
        className="login-hero"
        style={{ backgroundImage: "url('/images/login-hero.jpg')" }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">KAMPBOODSCHAPPEN</h1>
          <p className="hero-subtitle">Scoutinggroep John McCormick</p>
        </div>
      </div>

      <div className="login-box">
        <div className="logo-section">
          <img src="/images/jmc-logo.png" alt="JMC Logo" className="jmc-logo-img" />
        </div>

        <div className="form-container">
          <h2 className="form-title">Bestelportaal</h2>
          <p className="form-subtitle">Meld je aan met je gegevens</p>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="inlognaam">Gebruikersnaam</label>
              <input
                type="text"
                id="inlognaam"
                value={inlognaam}
                onChange={(e) => setInlognaam(e.target.value)}
                placeholder="Voer je gebruikersnaam in"
                required
                disabled={loading}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="wachtwoord">Wachtwoord</label>
              <input
                type="password"
                id="wachtwoord"
                value={wachtwoord}
                onChange={(e) => setWachtwoord(e.target.value)}
                placeholder="Voer je wachtwoord in"
                required
                disabled={loading}
                className="form-input"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? 'Bezig met inloggen...' : 'Inloggen'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
